import { render, staticRenderFns } from "./GroupDashboardCumulativeReturn.vue?vue&type=template&id=739bb824&"
import script from "./GroupDashboardCumulativeReturn.vue?vue&type=script&lang=js&"
export * from "./GroupDashboardCumulativeReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports